// Helper function to format currency
export const formatCurrency = (amount, language) => {
  if (language === 'en') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'KRW',
      minimumFractionDigits: 0,
    }).format(amount);
  }
  return new Intl.NumberFormat('ko-KR').format(amount) + '원';
};
